// One policy for both browser apps. Generic rejection values, SecurityErrors,
// network errors, anonymous frames and broken JS responses are not proof of an
// extension: keep them visible so application failures can be investigated.
const injectedMessages = [
  /^Invalid call to runtime\.sendMessage\(\)\. Tab not found\.$/,
  /iabjs_unified_bridge/,
  /_AutofillCallbackHandler/,
  /^WKWebView was deallocated before the message was delivered/,
  /^(?:Non-Error promise rejection captured with value: )?Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+$/,
];

const extensionUrl =
  /^(?:chrome-extension|moz-extension|safari-extension|safari-web-extension):\/\//;

export function beforeSendBrowser(event, hint) {
  const exceptions = event.exception?.values || [];
  const messages = [
    event.message,
    hint?.originalException?.message,
    ...exceptions.map((exception) => exception.value),
  ];
  if (
    messages.some(
      (message) =>
        typeof message === 'string' &&
        injectedMessages.some((pattern) => pattern.test(message)),
    )
  ) {
    return null;
  }

  // Keep mixed app/extension stacks. Only suppress when every exception has
  // frames and every frame is explicitly attributed to an extension URL.
  if (
    exceptions.length > 0 &&
    exceptions.every((exception) => {
      const frames = exception.stacktrace?.frames || [];
      return (
        frames.length > 0 &&
        frames.every((frame) => extensionUrl.test(frame.filename || ''))
      );
    })
  ) {
    return null;
  }

  if (
    messages.some(
      (message) =>
        typeof message === 'string' && message.includes('globalThis'),
    )
  ) {
    event.contexts = {
      ...event.contexts,
      browser_compatibility: {
        globalThis_supported: typeof globalThis !== 'undefined',
        polyfill_loaded:
          typeof window !== 'undefined' && window.globalThis === window,
      },
    };
    event.tags = { ...event.tags, browser_compatibility: 'globalThis' };
  }

  return event;
}
